// 页面性能优化工具
let performanceOptimized = false;
let webVitalsMonitored = false;

// 图片懒加载
export const lazyLoadImages = () => {
  const images = document.querySelectorAll('img[data-src]');

  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const img = entry.target as HTMLImageElement;
        img.src = img.dataset.src || '';
        img.removeAttribute('data-src');
        observer.unobserve(img);
      }
    });
  });

  images.forEach((img) => {
    imageObserver.observe(img);
  });
};

// 预加载关键资源
export const preloadCriticalResources = () => {
  const criticalImages = [
    '/imgs/home/yamida-logo.png',
    '/imgs/logos/worktool-logo.png',
    '/imgs/logos/chatlink-logo.png',
    '/imgs/logos/outbound-call-logo.png',
  ];

  criticalImages.forEach((src) => {
    const existing = document.querySelector(
      `link[rel="preload"][as="image"][href="${src}"]`,
    );
    if (existing) return;

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
};

// 延迟加载非关键CSS
export const loadNonCriticalCSS = () => {
  const nonCriticalCSS = [
    // 可以添加非关键的CSS文件
  ];

  nonCriticalCSS.forEach((href) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.media = 'print';
    link.onload = () => {
      link.media = 'all';
    };
    document.head.appendChild(link);
  });
};

// 优化字体加载
export const optimizeFontLoading = () => {
  const fontHref =
    'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxK.woff2';
  const existing = document.querySelector(
    `link[rel="preload"][as="font"][href="${fontHref}"]`,
  );
  if (existing) return;

  // 预加载关键字体
  const fontLink = document.createElement('link');
  fontLink.rel = 'preload';
  fontLink.as = 'font';
  fontLink.type = 'font/woff2';
  fontLink.crossOrigin = 'anonymous';
  fontLink.href = fontHref;
  document.head.appendChild(fontLink);
};

// 压缩和优化图片
export const optimizeImages = () => {
  const images = document.querySelectorAll('img');

  images.forEach((img) => {
    // 添加loading="lazy"属性
    if (!img.hasAttribute('loading')) {
      img.setAttribute('loading', 'lazy');
    }

    // 添加decoding="async"属性
    if (!img.hasAttribute('decoding')) {
      img.setAttribute('decoding', 'async');
    }
  });
};

// 初始化性能优化
export const initPerformanceOptimizations = () => {
  if (performanceOptimized) return;
  performanceOptimized = true;

  // 延迟执行非关键优化
  setTimeout(() => {
    lazyLoadImages();
    optimizeImages();
    loadNonCriticalCSS();
  }, 100);

  // 立即执行关键优化
  preloadCriticalResources();
  optimizeFontLoading();
};

// 监控Core Web Vitals
export const monitorCoreWebVitals = () => {
  if (webVitalsMonitored) return;
  webVitalsMonitored = true;

  // 监控LCP (Largest Contentful Paint)
  new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    const lastEntry = entries[entries.length - 1];
    console.log('LCP:', lastEntry.startTime);

    // 发送到分析服务
    if (window.trackEvent) {
      window.trackEvent(
        'performance',
        'lcp',
        window.location.pathname,
        Math.round(lastEntry.startTime),
      );
    }
  }).observe({ entryTypes: ['largest-contentful-paint'] });

  // 监控FID (First Input Delay)
  new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    entries.forEach((entry) => {
      console.log('FID:', entry.processingStart - entry.startTime);

      if (window.trackEvent) {
        window.trackEvent(
          'performance',
          'fid',
          window.location.pathname,
          Math.round(entry.processingStart - entry.startTime),
        );
      }
    });
  }).observe({ entryTypes: ['first-input'] });

  // 监控CLS (Cumulative Layout Shift)
  let clsValue = 0;
  new PerformanceObserver((entryList) => {
    const entries = entryList.getEntries();
    entries.forEach((entry) => {
      if (!entry.hadRecentInput) {
        clsValue += entry.value;
      }
    });

    console.log('CLS:', clsValue);

    if (window.trackEvent) {
      window.trackEvent(
        'performance',
        'cls',
        window.location.pathname,
        Math.round(clsValue * 1000),
      );
    }
  }).observe({ entryTypes: ['layout-shift'] });
};
